import { ICuocThaoLuan } from "../../../models/response/cuoc-thao-luan/ICuocThaoLuan";
import { ICuocThaoLuanComment } from "../../../models/response/cuoc-thao-luan/ICuocThaoLuanComment";
import { ICuocThaoLuanReaction } from "../../../models/response/cuoc-thao-luan/ICuocThaoLuanReaction";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eCuocThaoLuanDefine = {
    LOAD_INFO_START: 0,
    LOAD_INFO_SUCCESS: {} as ICuocThaoLuan,
    LOAD_INFO_ERROR: "",

    LOAD_COMMENT_START: 0,
    LOAD_COMMENT_SUCCESS: [] as ICuocThaoLuanComment[],
    LOAD_COMMENT_ERROR: "",

    LOAD_REACTION_START: 0,
    LOAD_REACTION_SUCCESS: [] as ICuocThaoLuanReaction[],
    LOAD_REACTION_ERROR: "",
    
    ADD_COMMENT_START: {} as ICuocThaoLuanComment,
    ADD_COMMENT_SUCCESS: {} as ICuocThaoLuanComment,
    ADD_COMMENT_ERROR: "",

    REMOVE_COMMENT_START: 0,
    REMOVE_COMMENT_SUCCESS: undefined,
    REMOVE_COMMENT_ERROR: "",

    ADD_REACTION_START: {} as ICuocThaoLuanReaction,
    ADD_REACTION_SUCCESS: {} as ICuocThaoLuanReaction,
    ADD_REACTION_ERROR: "",

    REMOVE_REACTION_START: 0,
    REMOVE_REACTION_SUCCESS: undefined,
    REMOVE_REACTION_ERROR: "",
}
export const eCuocThaoLuanActionTypeIds = generateActionTypeIds(eCuocThaoLuanDefine,"CUOC_THAO_LUAN")
export type ICuocThaoLuanActionTypes= IGenericActionType<typeof eCuocThaoLuanDefine, "CUOC_THAO_LUAN">